import { render, staticRenderFns } from "./UploadedFiles.vue?vue&type=template&id=109ae3bc&"
import script from "./UploadedFiles.vue?vue&type=script&lang=js&"
export * from "./UploadedFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/declan/code/fourpointzero/portal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VLayout,VProgressCircular,VSubheader})
